import http from "../http-common";

/**
 * Get fitness entries (for fitness level users)
 * Shows: guest name, entry time, entry count
 */
const getEntries = (page, pageSize, search, orderBy, orderDirection) => {
    const params = new URLSearchParams({
        page: page || 0,
        pageSize: pageSize || 100,
        search: search || '',
        orderBy: orderBy || 'time',
        orderDirection: orderDirection || 'DESC'
    });
    return http.get(`/v1/fitness/entries?${params.toString()}`);
};

/**
 * Get fitness report (for admin/reception level users)
 * Shows: guest name, room, start_date, end_date, entry times, entry count
 */
const getReport = (page, pageSize, search, orderBy, orderDirection) => {
    const params = new URLSearchParams({
        page: page || 0,
        pageSize: pageSize || 100,
        search: search || '',
        orderBy: orderBy || 'time',
        orderDirection: orderDirection || 'DESC'
    });
    return http.get(`/v1/fitness/report?${params.toString()}`);
};

/**
 * Get fitness summary grouped by user
 * Shows: unique guests with their total entry count
 */
const getSummary = (page, pageSize, search) => {
    const params = new URLSearchParams({
        page: page || 0,
        pageSize: pageSize || 100,
        search: search || ''
    });
    return http.get(`/v1/fitness/summary?${params.toString()}`);
};

/**
 * Get fitness device info
 */
const getDeviceInfo = () => {
    return http.get(`/v1/fitness/device`);
};

export default {
    getEntries,
    getReport,
    getSummary,
    getDeviceInfo
};
